import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import PhotoSwipe from './photoswipe.esm.js';
import PhotoSwipeVideoPlugin from './photoswipe-video-plugin.esm.js';

const arrowPrevSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path></svg>`;
const arrowNextSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path></svg>`;
const closeSVG = `<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path></svg>`;

const lightbox = new PhotoSwipeLightbox({
	gallery: '.photoswipe-gallery',
	children: '.photoswipe-gallery__item:not(.photoswipe-gallery__item--hidden)',
	pswpModule: PhotoSwipe,
	showHideAnimationType: 'none',
	bgOpacity: 1,
	zoom: true,
	arrowPrevSVG: arrowPrevSVG,
	arrowNextSVG: arrowNextSVG,
	closeSVG: closeSVG,
});
new PhotoSwipeVideoPlugin(lightbox, {});

lightbox.on('uiRegister', function() {
  lightbox.pswp.ui.registerElement({
    name: 'close-button',
    ariaLabel: 'Toggle zoom',
    className: 'pswp__custom-close-btn',
    appendTo: 'wrapper',
    isButton: true,
    html: {
      isCustomSVG: true,
      inner: closeSVG,
      outlineID: 'pswp__custom-close-icon'
    },
    onClick: () => lightbox.pswp.close()
  });
});

lightbox.init();

document
	.querySelectorAll('button.Gallery__item-button-zoom, [data-media-slide-id]')
	.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			const mediaId =
				button.getAttribute('data-media-id') || button.getAttribute('data-media-slide-id');
				const photoswipeItem = document.querySelector(
					`.photoswipe-gallery__item[data-media-reference-id="${mediaId}"]`,
				);
				window.queueMicrotask(() => {
					photoswipeItem.click();
				});
			
		});
	});
